import { axios } from "@/libraries/axios";
import { CreateChannelBodyPayloadSchema } from "@/schemas";
import type { PostCreateChannelResponse } from "@/types";

class ChannelService {
	async create(payload: CreateChannelBodyPayloadSchema) {
		try {
			const bodyParse = CreateChannelBodyPayloadSchema.safeParse(payload);
			if (!bodyParse.success) return Promise.reject(bodyParse.error);
			const res = await axios.post<PostCreateChannelResponse>(
				"/api/v1/channels",
				bodyParse.data,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export const channelService = Object.freeze(new ChannelService());
